/**
 * Builds the request body for POST /login-token with email and token.
 *
 * @param {string} email
 * @param {string} token
 * @returns {Object} Login request body
 */
export const buildLoginWithToken = (email, token) => ({
  email,
  token,
  includeToken: true,
  includeSecret: true,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
});

export default { buildLoginWithToken };
